// extracted by mini-css-extract-plugin
export default {"aboutback":"About_aboutback__WgJxV","aboutBg":"About_aboutBg__KsR6O"};